<template>
  <div>
    <section-header :ressource="ressource"
                    :isExtended='true'
                    :dialog="true"
                    :isAbstract="isAbstract"
                    @closeDialog=closeDialog>
    </section-header>

    <div class='p-4'>


      <select-field :editFieldInfo="documentTypeFieldInfo"
                    :value="getDocumentTypeValue()"
                    :items="documentTypes"
                    :disabled="cloneDocument.id > 0"
                    @updated="setDocumentType">
      </select-field>


      <div>
        <div v-html="cloneDocument.info"></div>
      </div>
      <v-file-input v-model="file"
                    :disabled="progress"
                    :accept="acceptedFiles"
                    :label="fileInputLabel">
      </v-file-input>
    </div>

    <div>
      <load-progress :condition="progress" :label="progressLabel"></load-progress>
    </div>

    <div v-if="errorMsg.length > 0">
      <div v-for="info in errorMsg" :key="info" class="grey lighten-2 p-0">
        <div class="text-h9">- {{ info }}</div>
      </div>
    </div>

    <div class="d-flex flex-row-reverse mt-4">
      <loader-button class="ms-2"
                     :label="buttonClose"
                     @callback="closeDialog">
      </loader-button>
      <loader-button class="ms-2"
                     :label="buttonAction"
                     :loading="loading"
                     @callback="submitFile"
                     :disabled="!file || progress">
      </loader-button>
    </div>
  </div>
</template>

<script lang="ts">
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import LoadProgress from '@/framework/base/components/LoadProgress.vue';
import Document from '@/generated/classes/Document';
import DocumentType from '@/generated/classes/DocumentType';
import Files from '@/generated/classes/Files';
import {mimeTypes} from '@/framework/files/helpers/FileTypes'
import {FwkButtons, FwkControls, RessourceFwkButton, RessourceFwkControl} from '@/ressources/globalRessources';
import HubServices from "@/generated/hub/HubServices";
import {FieldInfo, EditFieldType, EditFieldTheme} from '@/framework/base/components/FieldInfo';
import Item from '@/framework/base/classes/Item';
import {storeDocument, storeSession} from '@/generated/stores';
import SelectField from '@/framework/base/components/SelectField.vue';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import {GenSection, RessourceGenSection} from '@/generated/ressources/generatedRessources';
import {defineComponent, type PropType} from "vue";

export default defineComponent({
  components: {
    LoadProgress,
    LoaderButton,
    SelectField,
    SectionHeader
  },
  props: {
    showDialog: {
      type: Boolean
    },
    document: {
      type: Object as PropType<Document>,
      required: true
    },
    isAbstract: {
      type: Boolean
    },
  },
  created() {
    DocumentType.listType(this.cloneDocument).then((res) => {
      res.forEach((res) => {
        //const item = new Item(res.id, res.label);
        //const document = storeDocument.listDocument.find(a => a.typeId == res.id && a.id != this.cloneDocument.id && a.etablissementId == this.cloneDocument.etablissementId);
        //if (!document || this.cloneDocument.id > 0) {
        this.documentTypes.push(new Item(res.id, res.label));
        //}
      })
    })
    HubServices.onFilesProgress(this.setProgress);
  },
  data() {
    const documentTypes: Item[] = [];
    const errorMsg: string[] = [];
    const file: File | null = null;
    const cloneDocument = Document.fromJson(this.document);
    return {
      fileInputLabel: 'Choisir un fichier',
      progressLabel: "Changement en cours",
      progress: false,
      register: false,
      file,
      errorMsg,
      buttonAction: RessourceFwkButton(FwkButtons.IMPORTER).label,
      buttonClose: RessourceFwkButton(FwkButtons.FERMER).label,
      documentTypes,
      loading: false,
      cloneDocument
    };
  },
  computed: {
    ressource() {
      return RessourceGenSection(GenSection.IMPORT_DOC);
    },
    documentTypeFieldInfo(): FieldInfo {
      const ressource = RessourceFwkControl(FwkControls.DOCUMENT_TYPE);
      const type = EditFieldType.SELECT;
      const precision = 2;
      const format = null;
      const mask = null;
      const focus = null;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
    },
    userId(): number {
      const user = storeSession.connectedUser;
      if (user) {
        return user.id;
      } else {
        return 0;
      }
    },
    acceptedFiles(): string {
      let res = 'pdf'
      mimeTypes.forEach(m => {
        if (m.type == 'pdf') {
          res = m.mime;
        }
      })
      return res;
    }
  },

  methods: {
    setProgress(value: string) {
      this.progressLabel = value;
    },
    getDocumentTypeValue(): string {
      const item = this.documentTypes.find(a => a.key == this.cloneDocument.typeId);
      if (item) {
        return item.title;
      } else {
        return "";
      }
    },
    setDocumentType(item: Item) {
      this.cloneDocument.typeId = item.key;
      this.cloneDocument.persistant = true;
      this.cloneDocument.final = true;
      this.cloneDocument.gestionnaireId = this.userId;
    },
    submitFile(): void {
      this.loading = true;
      if (this.cloneDocument.id > 0) {
        if (this.file != null) {
          this.progress = true;
          const formData = new FormData()
          formData.append('file', this.file);
          formData.append('service', 'Document');
          formData.append('objId', this.cloneDocument.id.toString());
          Files.upload(formData).then(() => {
            this.loading = false;
            this.closeDialog();
          });
        }
      } else {
        this.cloneDocument.createForStoreDocument().then((res) => {
          if (this.file != null) {
            this.progress = true;
            const formData = new FormData()
            formData.append('file', this.file);
            formData.append('service', 'Document');
            formData.append('objId', res.id.toString());
            Files.upload(formData).then(() => {
              this.loading = false;
              this.closeDialog();
            });
          }
        })
      }
    },
    closeDialog() {
      this.file = null;
      this.errorMsg = [];
      this.progress = false;
      this.$emit('closeDialog');
    }
  }
})

</script>

<style scoped>
</style>


